/* eslint-disable max-len */
const QuestionStrategy = new Map([
  [{
    category: 1,
    status: [0],
    finish: false
  }, () => ('white')], // 0星
  [{
    category: 1,
    status: [1, 2],
    finish: true
  }, () => ('yellow')], // 2星/1星
  [{
    category: 1,
    status: [3],
    finish: true
  }, () => ('green')], // 3星
  [{
    category: 2,
    status: [0, 10],
    finish: false
  }, () => ('white')], // 未打开/未作答
  [{
    category: 2,
    status: [11, 2],
    finish: true
  }, () => ('yellow')], // 未运行/答题错误
  [{
    category: 2,
    status: [12, 1],
    finish: true
  }, () => ('green')], // 答题正确/运行正确
  [{
    category: 3,
    status: [0, 10],
    finish: false
  }, () => ('white')], // 未打开/未作答
  [{
    category: 3,
    status: [11, 5],
    finish: true
  }, () => ('yellow')], // 未运行/答题错误
  [{
    category: 3,
    status: [12, 4],
    finish: true
  }, () => ('green')], // 答题正确/运行正确
  [{
    category: 4,
    status: [0, 10],
    finish: false
  }, () => ('white')], // 未打开/未作答
  [{
    category: 4,
    status: [11, 5],
    finish: true
  }, () => ('yellow')], // 未运行/答题错误
  [{
    category: 4,
    status: [12, 4],
    finish: true
  }, () => ('green')], // 答题正确/运行正确
  [{
    category: 5,
    status: [0, 10],
    finish: false
  }, () => ('white')], // 未打开/未作答
  [{
    category: 5,
    status: [2],
    finish: true
  }, () => ('yellow')], // 答题错误
  [{
    category: 5,
    status: [3, 1],
    finish: true
  }, () => ('green')], // 答题正确/已订正
  [{
    category: 6,
    status: [0, 10],
    finish: false
  }, () => ('white')], // 未打开/未作答
  [{
    category: 6,
    status: [2],
    finish: true
  }, () => ('yellow')], // 答题错误
  [{
    category: 6,
    status: [3, 1],
    finish: true
  }, () => ('green')], // 答题正确/已订正
  [{
    category: 7,
    status: [0],
    finish: false
  }, () => ('white')], // 未打开
  [{
    category: 7,
    status: [11],
    finish: true
  }, () => ('yellow')], // 未运行
  [{
    category: 7,
    status: [12],
    finish: true
  }, () => ('green')], // 运行正确
  [{
    category: 8,
    status: [0, 10],
    finish: false
  }, () => ('white')], // 未打开/未作答
  [{
    category: 8,
    status: [11, 5],
    finish: true
  }, () => ('yellow')], // 未运行/答题错误
  [{
    category: 8,
    status: [12, 4],
    finish: true
  }, () => ('green')], // 运行正确
]);
export const genResult = (list) => {
  // eslint-disable-next-line no-param-reassign
  list.forEach(item => [...QuestionStrategy].filter(([key]) => (key.category === item.category && key.status.includes(item.result))).forEach(([key]) => {
    item.finish = key.finish;
  }));
  return list;
};

export default QuestionStrategy;
